import { render, staticRenderFns } from "./BaseTableDragDrop.vue?vue&type=template&id=0f9f1e5c&"
import script from "./BaseTableDragDrop.vue?vue&type=script&lang=js&"
export * from "./BaseTableDragDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports